import { render } from "./footer.vue?vue&type=template&id=46dbbbc5"
const script = {}

import exportComponent from "../../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__